<template>
  <div class="home" style="margin-top: 50px">
    Month: <input type="text" v-model="month" />
    <button @click="generateDiscountsReport">Generate discounts report</button>
    <button @click="generateDiscountsYearReport">Generate discounts year report</button>
    <div class="">
      <label>Upload revolut csv
        <select v-model="accountType">
          <option value="main">Main</option>
          <option value="suppliers">Suppliers</option>
          <option value="stripe">Stripe</option>
          <option value="clients">Clients Incomming</option>
          <option value="kevin">Kevin</option>
          <option value="poland">Poland</option>
        </select>
        <input type="file" id="file" ref="file" v-on:change="handleFileUpload"/>
      </label>
      <button v-on:click="submitFile()">Submit</button>
    </div>
    <div class="">
      <label>Upload stripe csv
        <select v-model="stripeAccountType">
          <option value="stripe">Stripe</option>
          <option value="balance-history">Balance history</option>
        </select>
        <input type="file" id="file" ref="file" v-on:change="handleStripeFileUpload"/>
      </label>
      <button v-on:click="submitStripeFile()">Submit</button>
    </div>
  <div>
    <select v-model="companyId">
      <option value="On8Fc1kC5oqGWPhYD1Ye">Senukai</option>
      <option value="MRgZen9daALiFj8qL3Ie">Topo Centras</option>
      <option value="ND58PRGjuJLylU0vY7Q4">Discontract</option>
      <option value="2i85i3iXID99cax9U89W">Avitela</option>
      <option value="AOUf1nxlHQFiSERqiVEM">Reside</option>
      <option value="gEZTzjEUZTxplkY24hrP">Baldai1</option>
      <option value="N1T0GuXThBjsvbdjMNzw">Trobos</option>
      <option value="HAIDEe15mim3kxQD4gCm">GR retail</option>
      <option value="5ixm46MkV2pT7iPUCdci">Ermitazas</option>
    </select>
    <input v-model="companyId"/>
    <br />
    <input v-model="externalDepartmentId" placeholder="Department ID"/>
    <button v-on:click="generateCompanyReport(companyId)">Generate Report CSV</button>
    <button v-on:click="generateCompanyXlsReport(companyId)">Generate Report XLS</button>
    <button v-on:click="generateCompanyDepartmentXlsReport(companyId)">Generate Department Report XLS</button>
    <label>Send LIVE report</label>
    <input type="checkbox" v-model="liveReport" />
    <button v-on:click="sendDepartmentReport(companyId, externalDepartmentId)">Send Department Report</button>
  </div>
  </div>
</template>

<style scoped lang="less">
  input {
    padding: 10px;
    margin-bottom: 20px;
  }
  button {
    display: block;
    margin: 0 auto;
    background-color: #333;padding: 10px;color:white;cursor:pointer;margin-bottom:20px;
  }
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import api from "../services/api";
import dayjs from 'dayjs';

export default {
  name: "finance",
  data: function() {
    return {
      month: dayjs().add(-4, 'week').format('YYYY-MM'),
      accountType: 'main',
      stripeAccountType: 'stripe',
      file: '',
      stripeFile: '',
      companyId: 'MRgZen9daALiFj8qL3Ie',
      externalDepartmentId: '',
      liveReport: false
    };
  },
  async created() {
  },
  methods: {
    handleFileUpload(event) {
      this.file = event.target.files[0];
      console.log(this.file);
    },
    handleStripeFileUpload(event) {
      this.stripeFile = event.target.files[0];
      console.log(this.stripeFile);
    },
    async submitFile() {
      let formData = new FormData();
      formData.append('file', this.file);
      const data = await api.postRevolutFile(this.month, this.accountType, formData);
      const blob = new Blob([data]);
      const a = window.document.createElement("a");
      a.href = window.URL.createObjectURL(blob, {type: "text/plain"});
      a.download = `revo-${this.accountType}-${this.month}.xml`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    async submitStripeFile() {
      let formData = new FormData();
      formData.append('file', this.stripeFile);
      const data = await api.postStripeFile(this.month, this.stripeAccountType, formData);
      const blob = new Blob([data]);
      const a = window.document.createElement("a");
      a.href = window.URL.createObjectURL(blob, {type: "text/plain"});
      a.download = `stripe-${this.stripeAccountType}-${this.month}.xml`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    async generateDiscountsReport() {
      const data = await api.generateDiscountsReport(this.month);
      const blob = new Blob([data]);
      const a = window.document.createElement("a");
      a.href = window.URL.createObjectURL(blob, {type: "text/plain"});
      a.download = `discounts-${this.month}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    ///month/:month/company-csv/:companyId
    async generateCompanyReport(companyId) {
      const data = await api.generateCompanyCsvReport(this.month, companyId);
      const blob = new Blob([data]);
      const a = window.document.createElement("a");
      a.href = window.URL.createObjectURL(blob, {type: "text/plain"});
      a.download = `company-report-${this.month}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    async generateCompanyXlsReport(companyId) {
      const file = await api.generateCompanyXlsReport(this.month, companyId);
      window.open(file.url, '_blank');
    },
    async generateCompanyDepartmentXlsReport(companyId) {
      const file = await api.generateCompanyDepartmentXlsReport(this.month, companyId, {externalDepartmentId: this.externalDepartmentId});
      window.open(file.url, '_blank');
    },
    async sendDepartmentReport(companyId, externalDepartmentId) {
      api.sendDepartmentReport(this.month, companyId, {externalDepartmentId, liveReport: this.liveReport});
    },
    async generateDiscountsYearReport() {
      const data = await api.generateDiscountsReport(this.month, {year: true});
      const blob = new Blob([data]);
      const a = window.document.createElement("a");
      a.href = window.URL.createObjectURL(blob, {type: "text/plain"});
      a.download = `discounts-${this.month}-year.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }
};
</script>
